<template>
    <div class="home-container">
        <el-row class="home" :gutter="responsiveGutter">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <div class="title">欢迎使用点名系统！</div>
                <el-card shadow="hover" class="user-card">
                    <div class="xingxi">个人信息</div>
                    <div class="user">
                        <img :src="imageUrl + avatar" alt="用户头像">
                        <div class="user-info">
                            <p class="name">{{nickname}}</p>
                        </div>
                    </div>
                    <div class="login-info">
                        <p>上次登录时间:<span>{{lastLoginTime | formatDate}}</span></p>
                    </div>
                </el-card>
            </el-col>
         
            <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
                <!-- 饼图 -->
                <el-card class="chart-card">
                    <div ref="videoEchart" class="echart-container"></div>
                </el-card>

                <!-- 销售额统计汇总 -->
                <el-card class="stats-card">
                    <div class="total-stats">
                        <el-statistic :value="todayTotal" prefix="今日销售额：" suffix="元" style="margin-right: 20px"/>
                        <el-statistic :value="monthTotal" prefix="本月销售额：" suffix="元" style="margin-right: 20px"/>
                        <el-statistic :value="allTotal" prefix="总销售额：" suffix="元"/>
                    </div>
                </el-card>

                <!-- 明细表格 -->
                <el-card class="table-card">
                    <div class="table-title">课程销售明细</div>
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        size="small"
                    >
                        <el-table-column prop="courseName" label="课程名称" align="center" />
                        <el-table-column prop="price" label="课程单价" align="center" />
                        <el-table-column prop="todayBuy" label="今日销售额" align="center" />
                        <el-table-column prop="monthBuy" label="本月销售额" align="center" />
                        <el-table-column prop="totalBuy" label="总销售额" align="center" />
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { debounce } from 'lodash';

export default {
    name: 'HomePage',
    data() {
        return {
            avatar: '',
            nickname: '',
            lastLoginTime: '',
            tableData: [],
            todayTotal: 0,
            monthTotal: 0,
            allTotal: 0,
            observer: null,
            pieOptions: {
                title: {
                    text: '课程销售额统计',
                    left: 'center',
                },
                tooltip: {
                    trigger: "item",
                    formatter: '{a} <br/>{b}: ￥{c} ({d}%)'
                },
                legend: {
                    orient: 'horizontal',
                    bottom: 0,
                    left: 'center',
                },
                color: [
                    "#0f78f4",
                    "#dd536b",
                    "#9462e5",
                    "#a6a6a6",
                    "#e1bb22",
                    "#39c362",
                    "#3ed1cf",
                ],
                series: [
                    {
                        name: '销售额',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            formatter: '{b}: ￥{c}'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: [],
                    }
                ]
            },
            screenWidth: document.documentElement.clientWidth
        }
    },
    computed: {
        responsiveGutter() {
            return this.screenWidth < 768 ? 10 : 20;
        }
    },
    filters: {
        formatDate(value) {
            if (!value) return '未知'
            const date = new Date(value)
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        },
    },
    created() {
        this.userInfo()
        this.getMemberList()
        this.$bus.$on('update-user-info', (data) => {
            if(data == 1){
                this.userInfo()
            }
        })
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        handleResize: debounce(function() {
            this.screenWidth = document.documentElement.clientWidth;
            if (this.$refs.videoEchart) {
                const chart = echarts.getInstanceByDom(this.$refs.videoEchart);
                if (chart) {
                    chart.resize();
                }
            }
        }, 200),
        
        getMemberList() {
            this.$http.get('/api/members')
                .then(response => {
                    const memberData = response.data.data;
                    this.processMemberData(memberData);
                })
                .catch(error => {
                    console.error('获取会员列表失败:', error);
                });
        },
        processMemberData(memberData) {
            const courseMap = {};
            const today = new Date();
            const todayStr = today.toISOString().split('T')[0];
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            
            memberData.forEach(item => {
                const courseName = item.courseName;
                const price = item.course.price || 0;
                const totalLessons = item.totalLessons || 1;
                const realTotalPrice = price * totalLessons;

                const updatedAt = new Date(item.course.updatedAt);
                const isToday = updatedAt.toISOString().split('T')[0] === todayStr;
                const isThisMonth = updatedAt.getMonth() + 1 === month && updatedAt.getFullYear() === year;
                
                if (!courseMap[courseName]) {
                    courseMap[courseName] = {
                        courseName: courseName,
                        todayBuy: 0,
                        monthBuy: 0,
                        totalBuy: 0,
                        price: price
                    };
                }
                
                courseMap[courseName].totalBuy += realTotalPrice;
                if (isToday) courseMap[courseName].todayBuy += realTotalPrice;
                if (isThisMonth) courseMap[courseName].monthBuy += realTotalPrice;
            });
            
            this.tableData = Object.values(courseMap);
            this.calculateTotal();
            
            const chartData = this.tableData.map(item => ({
                value: item.totalBuy,
                name: item.courseName
            }));
            
            this.pieOptions.series[0].data = chartData;
            
            this.$nextTick(() => {
                const ThreeEcharts = echarts.init(this.$refs.videoEchart);
                ThreeEcharts.setOption(this.pieOptions);
                this.observer = new ResizeObserver(() => ThreeEcharts.resize());
                if (this.$refs.videoEchart) this.observer.observe(this.$refs.videoEchart);
            });
        },
        calculateTotal() {
            let today = 0, month = 0, all = 0;
            this.tableData.forEach(item => {
                today += item.todayBuy;
                month += item.monthBuy;
                all += item.totalBuy;
            });
            this.todayTotal = today;
            this.monthTotal = month;
            this.allTotal = all;
        },
        userInfo() {
            this.$http.get('/api/adminAuth/profile')
                .then(response => {
                    this.avatar = response.data.data.avatar;
                    this.nickname = response.data.data.nickname;
                    this.lastLoginTime = response.data.data.lastLoginTime;
                })
                .catch(error => {
                    console.error('获取用户信息失败:', error);
                    this.$message.error('获取用户信息失败');
                });
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.observer) this.observer.disconnect();
    }
}
</script>

<style lang="less" scoped>
.home-container {
    padding: 10px;
    box-sizing: border-box;
}

.home {
    height: 100%;
    overflow: hidden;
    
    .user-card {
        margin-bottom: 20px;
    }
    
    .chart-card, .stats-card, .table-card {
        margin-top: 15px;
    }

    .user {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
        padding-bottom: 20px;

        img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-bottom: 15px;
            @media (max-width: 768px) {
                width: 100px;
                height: 100px;
            }
        }
    }

    .user-info .name {
        font-size: 24px;
        margin-bottom: 10px;
        @media (max-width: 768px) {
            font-size: 20px;
        }
    }

    .login-info p {
        line-height: 24px;
        font-size: 14px;
        color: #999;
        text-align: center;
        span { color: #666; margin-left: 10px; }
    }

    .xingxi {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        @media (max-width: 768px) { font-size: 16px; }
    }
    
    .title {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        @media (max-width: 768px) {
            margin-bottom: 15px;
            font-size: 16px;
        }
    }
    
    .echart-container {
        width: 100%;
        height: 400px;
        @media (max-width: 768px) { height: 300px; }
        @media (max-width: 480px) { height: 250px; }
    }

    .total-stats {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 10px 0;
        gap: 10px;
    }
    .table-title{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
    }
}

@media (max-width: 992px) {
    .home .el-col {
        margin-bottom: 15px;
    }
}
</style>